import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class EventListenerUtility {
    /**
     * Helper to add an event listener and return a function that removes
     * the event listener.
     *
     * @param element
     * @param eventName
     * @param callback
     */
    addEventListener(
        element: HTMLElement,
        eventName: string,
        callback: EventListener
    ): Function {
        element.addEventListener(eventName, callback);
        return () => {
            element.removeEventListener(eventName, callback);
        };
    }
}
